<template>
  <b-dropdown
    no-caret
    right
    variant="light"
    size="sm"
    toggle-class="p-0"
    menu-class="p-0"
  >
    <template #button-content>
      <span class="fa-stack">
        <span class="fas fa-circle fa-stack-2x text-blue fa-fw" />
        <span class="fas fa-tally fa-stack-1x fa-inverse fa-fw" />
      </span>
    </template>

    <!-- <div style="width: 400px;"> -->
    <div class="synaplus-cosmo-w-480">
      <!--       <h5 class="my-3 pl-3">
        <span class="d-flex align-self-center">
          {{ $t('selected_metavariables') }}
        </span>
      </h5> -->

      <div class="my-3 pl-3 h6 d-flex justify-content-between">
        <span>
          {{ $t('selected_metavariables') }}
        </span>
        <span class="mr-5">
          {{ $t('computation_time') }}
        </span>
      </div>

      <b-list-group
        :disabled="
          _.isEmpty(available_metavariables_items) &&
            _.isEmpty(failed_metavariables_items)
        "
      >
        <!--         <b-list-group-item
          :disabled="_.isEmpty(available_metavariables_items)"
          class="d-flex border-bottom-0 rounded-0"
        >
          <b-form-checkbox
            :checked="select_all"
            :value="true"
            :unchecked_value="false"
            @change="toggle_select_all"
          >
            <span class="ml-4"> {{ $t('select_all') }} </span>
          </b-form-checkbox>
        </b-list-group-item> -->

        <b-list-group-item
          :disabled="_.isEmpty(available_metavariables_items)"
          class="d-flex justify-content-between border-bottom-0 rounded-0"
        >
          <b-form-checkbox
            :checked="select_all"
            :value="true"
            :unchecked_value="false"
            @change="toggle_select_all"
          >
            <span class="ml-4"> {{ $t('select_all') }} </span>
          </b-form-checkbox>

          <span class="mr-5">
            {{ formatted_computation_time }}
          </span>
        </b-list-group-item>

        <b-form-checkbox-group v-model="local_value">
          <b-list-group-item
            v-for="metavariable_dict in available_metavariables_items"
            :key="JSON.stringify(metavariable_dict)"
            class="d-flex justify-content-between align-items-center"
          >
            <div class="d-flex align-items-center">
              <b-form-checkbox :value="metavariable_dict.value">
                <pre
                  class="mb-0 ml-3 p-1"
                  v-html="metavariable_dict.text"
                ></pre>
              </b-form-checkbox>
            </div>

            <b-button
              size="sm"
              variant="outline-secondary"
              @click="recompute_metavariables_dict(metavariable_dict.value)"
            >
              <span class="far fa-redo-alt fa-fw fa-xs" />
            </b-button>

            <!-- <div>
              <span class="mx-4">
                {{
                  metavariables_dicts_computation_time[metavariable_dict.value]
                }}
              </span>

              <b-button
                size="sm"
                variant="outline-secondary"
                @click="recompute_metavariables_dict(metavariable_dict.value)"
              >
                <span class="far fa-redo-alt fa-fw fa-xs" />
              </b-button>
            </div> -->
          </b-list-group-item>
        </b-form-checkbox-group>

        <b-list-group-item
          v-for="metavariable_dict in failed_metavariables_items"
          :key="JSON.stringify(metavariable_dict)"
          variant="danger"
          class="d-flex align-items-center"
        >
          <b-form-checkbox disabled />
          <pre class="mb-0 ml-3 p-1" v-html="metavariable_dict" />
        </b-list-group-item>
      </b-list-group>
    </div>
  </b-dropdown>
</template>

<i18n>
{
  "en": {
    "selected_metavariables": "Selected metavariables",
    "computation_time": "Computation time"
  },
  "fr": {
    "selected_metavariables": "Métavariables sélectionnées",
    "computation_time": "Temps de calcul"
  }
}
</i18n>

<script>
import _ from 'lodash'
import moment from 'moment'
import Vue from 'vue'

import humanize_duration from 'humanize-duration'
// import { subscription_mixin } from '@/components/mixin.js'

import {
  dict_from_frozendict,
  extended_dict_forEach,
  json_syntax_highlight,
} from '@/utils.js'

// *****************************************************************************

export default {
  name: 'MetavariablesSelector',
  props: [
    'computation_time',
    'value',
    'available_metavariables_dicts',
    'failed_metavariables_dicts',
  ],
  // mixins: [subscription_mixin],
  data() {
    return {
      local_value: [],
      select_all: true,
    }
  },
  computed: {
    _() {
      return _
    },
    available_metavariables_items() {
      let res = []
      _.forEach(
        this.available_metavariables_dicts,
        (metavariables_dict, poid) => {
          res.push({
            value: parseInt(poid),
            text: json_syntax_highlight(JSON.stringify(metavariables_dict)),
          })
        }
      )

      return res
    },

    failed_metavariables_items() {
      let res = _.map(this.failed_metavariables_dicts, elt =>
        json_syntax_highlight(JSON.stringify(elt))
      )

      return res
    },

    // brick_elapsed_computation_time() {
    //   let init_date = moment('12/04/2021 10:00:00', 'DD/MM/YYYY HH:mm:ss')
    //   let diff = moment().diff(init_date)
    //   let duration = moment.duration(diff)
    //   let res =
    //     Math.floor(duration.asHours()) +
    //     moment.utc(diff).format('[h] mm[m] ss[s]')
    //   return res
    // },

    // brick_elapsed_computation_time() {
    //   let res = this.fetch_brick_progress(
    //     `brick_computation_time_${this.brick_id}`,
    //     this.brick_id
    //   )

    //   console.log('computation_time', res)
    //   // let init_date = moment('12/04/2021 10:00:00', 'DD/MM/YYYY HH:mm:ss')
    //   // let diff = moment().diff(init_date)
    //   // let duration = moment.duration(diff)
    //   // let res =
    //   //   Math.floor(duration.asHours()) +
    //   //   moment.utc(diff).format('[h] mm[m] ss[s]')
    //   return res
    // },

    // metavariables_dicts_computation_time() {
    //   let init_date = moment('12/04/2021 10:00:00', 'DD/MM/YYYY HH:mm:ss')
    //   let res = {}
    //   _.forEach(this.available_metavariables_dicts, (value, key) => {
    //     let diff = moment().diff(init_date)
    //     let duration = moment.duration(diff)
    //     res[key] =
    //       Math.floor(duration.asHours()) +
    //       moment.utc(diff).format('[h] mm[m] ss[s]')
    //   })
    //   // res = _.map(this.available_metavariables_dicts, (key, value) => res[key])
    //   return res
    // },
    formatted_computation_time() {
      let res = humanize_duration(this.computation_time * 1000, {
        language: this.$store.state.locale,
        maxDecimalPoints: 1,
      })
      return res
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, ov)) {
          this.local_value = _.cloneDeep(nv)
        }
      },
    },
    local_value: {
      immediate: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, ov)) {
          this.$emit('input', _.cloneDeep(nv))
          if (nv.length == this.available_metavariables_items.length) {
            this.select_all = true
          } else {
            this.select_all = false
          }
        }
      },
    },
    available_metavariables_dicts: {
      immediate: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, ov)) {
          this.toggle_select_all(true)
        }
      },
    },
  },

  methods: {
    recompute_metavariables_dict(poid) {
      this.$emit('recompute', poid)
    },

    toggle_select_all(checked) {
      let res = []
      if (checked) {
        res = _.map(this.available_metavariables_items, 'value')
      }
      this.local_value = res
    },
  },
}
</script>
